// react
import React, { useMemo } from "react";
import moment from "moment";
// UI
import {
  CardElement,
  HomePageTable,
} from "../../../components/Common/UIElements";

// processing
import OnboardingHomePageTopBar from "../../../components/Onboarding/Dashboard/OnboardingHomePageTopBar";
import OnboardingHomePageTable from "../../../components/Onboarding/Dashboard/OnboardingHomePageTable";
import { useGetAllCustomers } from "../../../hooks/Onboarding/onboarding.hooks";
import useTableSearch from "../../../hooks/table-search.hooks";
import { BILLING_METHOD } from "../../../utils/onboarding-helper";

// css
import "./styles.css";

// columns that could be searched
const searchableColumns = [
  "customer_name",
  "address",
  "project_overview",
  "contract_date",
  "effective_date",
  "solution",
  "corporate_contact_first_name",
  "corporate_contact_last_name",
  "corporate_contact_email",
  "billing_address",
  "billing_contact_name",
  "billing_phone_number",
  "billing_method",
  "billing_timeline",
  "status",
];

const OnboardingHomePage = () => {
  // fetch onboarding customer data
  const { isLoading: isLoadingCustomers, data: apiCustomerData } =
    useGetAllCustomers();

  // custom hook for external multi column table data searching
  const {
    filteredTableData,
    searchedColumns,
    updateSearchMeta,
    searchMeta,
    searchedWords,
  } = useTableSearch({
    searchableColumns,
    allData: apiCustomerData,
  });

  const customerData = useMemo(() => {
    let customers;

    if (Object.keys(searchMeta).length > 0 && filteredTableData) {
      customers = [...filteredTableData];
    } else {
      customers = apiCustomerData;
    }

    return customers?.map((customer) => {
      return {
        _id: customer._id,
        customer_name: customer.customer_name,
        address: [
          customer.address_line_1,
          customer.address_line_2,
          customer.city,
          customer.state,
          customer.zip_code,
          customer.country,
        ].join(", "),
        project_overview: customer.project_overview,
        contract_date: moment(customer.contract_date).format("MM.DD.YYYY"),
        effective_date: moment(customer.effective_date).format("MM.DD.YYYY"),
        solution: customer.solution,
        corporate_contact_first_name: customer.corporate_contact_id?.first_name,
        corporate_contact_last_name: customer.corporate_contact_id?.last_name,
        corporate_contact_email: customer.corporate_contact_id?.email,
        billing_address:
          customer.billing_method === BILLING_METHOD.CORPORATE
            ? [
                customer.billing_details.address_line_1,
                customer.billing_details.address_line_2,
                customer.billing_details.city,
                customer.billing_details.state,
                customer.billing_details.zip_code,
                customer.billing_details.country,
              ].join(", ")
            : BILLING_METHOD.INDIVIDUAL,
        billing_contact_name:
          customer.billing_method === BILLING_METHOD.CORPORATE
            ? customer.billing_details.name
            : BILLING_METHOD.INDIVIDUAL,
        billing_phone_number:
          customer.billing_method === BILLING_METHOD.CORPORATE
            ? customer.billing_details.phone_number
            : BILLING_METHOD.INDIVIDUAL,
        billing_method: customer.billing_method,
        billing_timeline: customer.billing_timeline,
        status: customer.status,
      };
    });
  }, [apiCustomerData, searchMeta, filteredTableData]);

  return (
    <CardElement title="System Discovery">
      <>
        <OnboardingHomePageTopBar updateSearchMeta={updateSearchMeta} />
        <HomePageTable>
          <OnboardingHomePageTable
            searchedColumns={searchedColumns}
            customerData={customerData}
            searchedWords={searchedWords}
            isLoadingCustomers={isLoadingCustomers}
          />
        </HomePageTable>
      </>
    </CardElement>
  );
};

export default OnboardingHomePage;
